export const USER = {
  LOGIN: "USER.LOGIN",
  LOGIN_SUCCESS: "USER.LOGIN_SUCCESS",
  LOGIN_ERROR: "USER.LOGIN_ERROR",
  FETCH: "USER.FETCH",
  FETCH_SUCCESS: "USER.FETCH_SUCCESS",
  FETCH_ERROR: "USER.FETCH_ERROR",
  EDIT: "USER.EDIT",
  ADD: "USER.ADD",
  DELETE: "USER.DELETE"
};

export default USER;
